import axiosConfig from "./axiosConfig";

// Service pour gérer les requêtes API des services médicaux
const OffresService = {
  // Récupérer tous les services
  getAllServices: async () => {
    try {
      const response = await axiosConfig.get("/services");
      return response.data;
    } catch (error) {
      console.error("Erreur API getAllServices:", error);
      throw error;
    }
  },

  // Créer un nouveau service
  createService: async (serviceData) => {
    try {
      const formData = new FormData();

      formData.append("nom", serviceData.nom);
      formData.append("description", serviceData.description);
      formData.append("pathologie", serviceData.pathologie);
      formData.append("chefServiceId", serviceData.chefServiceId);
      formData.append("majorId", serviceData.majorId);

      if (serviceData.photo) {
        formData.append("photo", serviceData.photo);
      }

      const response = await axiosConfig.post("/services", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Erreur API createService:", error);
      throw error;
    }
  },

  // Récupérer un service par ID
  getServiceById: async (id) => {
    try {
      const response = await axiosConfig.get(`/services/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur API getServiceById:", error);
      throw error;
    }
  },

  // Mettre à jour un service
  updateService: async (id, serviceData) => {
    try {
      const formData = new FormData();

      formData.append("nom", serviceData.nom);
      formData.append("description", serviceData.description);
      formData.append("pathologie", serviceData.pathologie);
      formData.append("chefServiceId", serviceData.chefServiceId);
      formData.append("majorId", serviceData.majorId);

      if (serviceData.photo) {
        formData.append("photo", serviceData.photo);
      }

      const response = await axiosConfig.put(`/services/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Erreur API updateService:", error);
      throw error;
    }
  },

  // Supprimer un service
  deleteService: async (id) => {
    try {
      await axiosConfig.delete(`/services/${id}`);
      return true;
    } catch (error) {
      console.error("Erreur API deleteService:", error);
      throw error;
    }
  },
};

export { OffresService };